import * as ACT from "../actions/areaActions";

export function area(state = {}, action) {
    switch (action.type) {

        case ACT.STATE_SET_ITEM:
            return {
                ...state,
                stateTargetItem: action.data,
            };
        case ACT.STATE_ADD_ITEM:
            return {
                ...state,
                stateAddItem: action.data,
            };
        case ACT.STATE_SET_ALL:
            return {
                ...state,
                stateList: action.data,
            };
        case ACT.CITY_GET_ITEM:
            return {
                ...state,
                cityGetItem: action.data,
            };
        case ACT.CITY_SET_ITEM:
            return {
                ...state,
                cityTargetItem: action.data,
            };
        case ACT.CITY_ADD_ITEM:
            return {
                ...state,
                cityAddItem: action.data,
            };
        case ACT.CITY_GET_ALL:
            return {
                ...state,
                cityList: action.data,
            };
        case ACT.AREA_GET_ALL:
            return {
                ...state,
                areaList: action.data,
            };

        case ACT.AREA_SET_CITY:
            return {
                ...state,
                cityList: action.data,
            };

        default:
            return state
    }
};